import classNames from 'classnames';
import React from 'react';

import type { TestProps } from '../../../utils/test/models';

import './Content.scss';

export interface ContentProps extends TestProps, React.PropsWithChildren {
    className?: string;
    skipBow?: boolean;
}

const Content: React.FC<ContentProps> = ({ className, skipBow, children, dataTestId }) => {
    return (
        <div data-testid={dataTestId} className={classNames(className, 'sgw-content', { 'skip-bow': skipBow })}>
            {children}
        </div>
    );
};

export default Content;
